import http from "@/services/http";

/**
 * Vincula duas entidades clínicas quaisquer.
 * @param {object} payload { source_type, source_id, target_type, target_id, relation_type?, notes? }
 */
export function linkCorrelation(payload) {
  return http.post("/api/correlations/link", payload);
}

/**
 * Remove uma correlação (soft delete).
 */
export function unlinkCorrelation(id) {
  return http.delete(`/api/correlations/unlink/${id}`);
}

/**
 * Lista as correlações de uma entidade, já com a outra ponta resolvida.
 * @returns {Promise<Array<{correlation_id:number, relation_type:string|null, other:object}>>}
 */
export async function listCorrelations(type, id) {
  const { data } = await http.get(`/api/correlations/by-entity/${type}/${id}`);
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Pendências de correlação do paciente.
 * @returns {Promise<{medications_without_condition:object[], conditions_without_medication:object[]}>}
 */
export async function getPendencias(patientId) {
  const { data } = await http.get(`/api/correlations/pendencias/${patientId}`);
  return data?.status === "success"
    ? data.data
    : { medications_without_condition: [], conditions_without_medication: [] };
}

/**
 * Tudo que o paciente tem, normalizado para o seletor universal de vínculo.
 * @returns {Promise<Array<{type:string, id:number, label:string, code:string|null}>>}
 */
export async function getLinkableEntities(patientId) {
  const { data } = await http.get(`/api/correlations/linkable/${patientId}`);
  return data?.status === "success" ? data.data || [] : [];
}

/**
 * Todas as correlações do paciente, com as duas pontas resolvidas.
 * @returns {Promise<Array<{correlation_id:number, relation_type:string|null, source:object, target:object}>>}
 */
export async function getPatientCorrelations(patientId) {
  const { data } = await http.get(`/api/correlations/by-patient/${patientId}`);
  return data?.status === "success" ? data.data || [] : [];
}
